/*
    NOTE: AuthorizedApi has been deprecated. Please use src/js/api/* for all future API requests.
*/

import $ from "jquery";

import * as api from "./api";
import { getPythonBackendUrl } from "js/utils/getBackendUrl";
import { useUserSessionStore } from "stores/v2/userSessionStore";

const pythonBackendUrl = getPythonBackendUrl(window.location.hostname);

export default class Api {
	static get(url, callbackSuccess, callbackError) {
		const headers = {
			Authorization: useUserSessionStore.getState().getToken(),
			User: useUserSessionStore.getState().getActiveUser(),
			Device: useUserSessionStore.getState().getActiveDevice(),
		};

		$.ajax({
			url: pythonBackendUrl + url,
			type: "get",
			dataType: "json",
			headers: headers,
			contentType: "application/json; charset=utf-8",
			success: function (data) {
				if (callbackSuccess) callbackSuccess(data);
			},
			error: function (jqXHR, exception) {
				if (jqXHR.status === 403) {
					useUserSessionStore.getState().handleInvalidTokenError(exception);
				}
				if (callbackError) callbackError(exception);
			},
		});
	}

	static delete(url, callbackSuccess) {
		const headers = {
			Authorization: useUserSessionStore.getState().getToken(),
			User: useUserSessionStore.getState().getActiveUser(),
			Device: useUserSessionStore.getState().getActiveDevice(),
		};

		$.ajax({
			url: pythonBackendUrl + url,
			type: "delete",
			dataType: "json",
			headers: headers,
			contentType: "application/json; charset=utf-8",
			success: function (data) {
				if (callbackSuccess) callbackSuccess(data);
			},
			error: function (jqXHR, exception) {
				if (jqXHR.status === 403) {
					useUserSessionStore.getState().handleInvalidTokenError(exception);
				}
			},
		});
	}

	static async DeleteAsync(url, data, successCallback, errorCallback = null) {
		const options = {
			method: "DELETE",
			headers: {
				Authorization: useUserSessionStore.getState().getToken(),
				User: useUserSessionStore.getState().getActiveUser(),
				Device: useUserSessionStore.getState().getActiveDevice(),
				"Content-Type": "application/json",
			},
			body: JSON.stringify(data),
		};

		try {
			const data = await api.fetch(`${pythonBackendUrl}${url}`, options, false);
			if (successCallback) successCallback(data);
		} catch (error) {
			console.log(error);
			if (errorCallback) errorCallback(error);
		}
	}

	static post(url, data, callbackSuccess, callbackError) {
		this.postWithTimeout(url, data, callbackSuccess, callbackError, 0);
	}

	static postWithTimeout(url, data, callbackSuccess, callbackError, timeout) {
		const headers = {
			Authorization: useUserSessionStore.getState().getToken(),
			User: useUserSessionStore.getState().getActiveUser(),
			Device: useUserSessionStore.getState().getActiveDevice(),
		};

		$.ajax({
			url: pythonBackendUrl + url,
			type: "post",
			dataType: "json",
			headers: headers,
			timeout: timeout,
			contentType: "application/json; charset=utf-8",
			success: function (data) {
				if (callbackSuccess) callbackSuccess(data);
			},
			error: function (jqXHR, exception) {
				if (jqXHR.status === 403) {
					useUserSessionStore.getState().handleInvalidTokenError(exception);
				} else if (callbackError) {
					callbackError(jqXHR.responseJSON);
				}
			},
			data: JSON.stringify(data),
		});
	}

	static async PostAsync(url, data, successCallback, errorCallback = null) {
		const options = {
			method: "POST",
			headers: {
				Authorization: useUserSessionStore.getState().getToken(),
				User: useUserSessionStore.getState().getActiveUser(),
				Device: useUserSessionStore.getState().getActiveDevice(),
				"Content-Type": "application/json",
			},
			body: JSON.stringify(data),
		};

		try {
			const data = await api.fetch(`${pythonBackendUrl}${url}`, options, false);
			if (successCallback) successCallback(data);
		} catch (error) {
			console.log(error);
			if (errorCallback) errorCallback(error);
		}
	}

	static put(url, data, callbackSuccess, callbackError) {
		const headers = {
			Authorization: useUserSessionStore.getState().getToken(),
			User: useUserSessionStore.getState().getActiveUser(),
			Device: useUserSessionStore.getState().getActiveDevice(),
		};

		$.ajax({
			url: pythonBackendUrl + url,
			type: "put",
			dataType: "json",
			headers: headers,
			contentType: "application/json; charset=utf-8",
			success: function (data) {
				if (callbackSuccess) callbackSuccess(data);
			},
			error: function (jqXHR, exception) {
				if (jqXHR.status === 403) {
					useUserSessionStore.getState().handleInvalidTokenError(exception);
				} else if (callbackError) {
					callbackError(jqXHR.responseJSON);
				}
			},
			data: JSON.stringify(data),
		});
	}

	static unauthenticatedPost(url, data, callbackSuccess, callbackError) {
		$.ajax({
			url: pythonBackendUrl + url,
			type: "post",
			dataType: "json",
			contentType: "application/json; charset=utf-8",
			success: function (data) {
				if (callbackSuccess) callbackSuccess(data);
			},
			error: function (jqXHR, exception) {
				if (jqXHR.status === 403) {
					useUserSessionStore.getState().handleInvalidTokenError(exception);
				} else {
					if (callbackError !== undefined) {
						callbackError(jqXHR.responseJSON);
					}
				}
			},
			data: JSON.stringify(data),
		});
	}

	static unauthenticatedGet(url, callbackSuccess, callbackError) {
		$.ajax({
			url: pythonBackendUrl + url,
			type: "get",
			contentType: "application/json; charset=utf-8",
			success: function (data) {
				if (callbackSuccess) callbackSuccess(data);
			},
			error: function (jqXHR, exception) {
				if (callbackError !== undefined) {
					callbackError(exception);
				}
			},
		});
	}
}
